export enum CTASource {
  STICKY_CARD = 'STICKY_CARD',
  EXIT_INTENT_MODAL = 'EXIT_INTENT_MODAL',
}
